import { useMutation, useQueryClient } from "react-query";
import { postReminderNote } from "@/services/tasks";

/** Mutation hook for posting a new note on a reminder. Invalidates the notes list on success. */
export function useCreateReminderNote(patientUid, reminderId) {
  var queryClient = useQueryClient();
  return useMutation(function (note) {
    return postReminderNote(patientUid, reminderId, note);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(["reminder-notes", patientUid, reminderId]);
    }
  });
}